import { render, staticRenderFns } from "./DeveloperDetailPage.vue?vue&type=template&id=5cb6f53d&scoped=true"
import script from "./DeveloperDetailPage.vue?vue&type=script&lang=js"
export * from "./DeveloperDetailPage.vue?vue&type=script&lang=js"
import style0 from "./DeveloperDetailPage.vue?vue&type=style&index=0&id=5cb6f53d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6f53d",
  null
  
)

export default component.exports